import checkinApiReducer from "./checkinApiSlice";

export default checkinApiReducer;
export {
  checkinDocumentThunk,
  checkinDocumentsBulkThunk,
  clearCheckinError,
  BROWSE_FILE_FIELD,
} from "./checkinApiSlice";
